(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-advertising-source-report', {
            parent: 'report',
            url: '/employee-advertising-source-report?page&sort&search&searchType&startDate&endDate&divisionId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.employeesAdvertisingSourcesReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/employee-advertising-source-report/employee-advertising-source-report.html',
                    controller: 'EmployeeAdvertisingSourceReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'employeeName,asc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null,
                divisionId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
